// utils/similar.js —— 查词/相似词/音节相关纯函数与音频播放工具
// 从小程序组件（simpleWord/individualPhonetic/AmericanSyllable/freeSelectPhonetic）提取复用

// 播放单词发音（有道语音合成，type=1 英式）
export function playWord(word) {
  if (!word) return
  const audio = new Audio(
    'https://dict.youdao.com/dictvoice?audio=' + encodeURIComponent(word) + '&type=1'
  )
  audio.play()
}

// 播放单个音标发音（服务器托管音频，音标为 IPA 符号，需 encodeURIComponent）
export function playPhonetic(phone) {
  if (!phone) return
  const raw = String(phone).trim()
  // 半角冒号结尾的音标转全角，匹配服务器文件名
  const p = raw.endsWith(':') ? raw.slice(0, -1) + '：' : raw
  const audio = new Audio(
    'https://www.sousouwords.com/img/weapp/audios/' + encodeURIComponent(p) + '.mp3'
  )
  audio.play()
}

// 根据 = 分割字符串，返回数组（逗号分隔多套方案时只取第一套）
export function depart(str) {
  if (typeof str !== 'string' || !str.trim()) return []
  const content = str.trim()
  const primary = content.split(',')[0].trim()
  if (primary.includes('=')) {
    return primary.split('=').map((item) => item.trim())
  }
  return primary ? [primary] : []
}

// 拆分 similarWord：<br> 换行 + / 或 \ 分隔 → 单词数组，每项标记 isCn（是否含汉字）
export function splitWords(str) {
  if (typeof str !== 'string' || !str.trim()) return []
  return str
    .replace(/<br\s*\/?\s*>/gi, '\n')
    .split(/[/\\\n]+/)
    .map((item) => {
      const t = item.trim()
      if (!t) return null
      return { text: t, isCn: /[\u4e00-\u9fa5]/.test(t) }
    })
    .filter((item) => item)
}

// 把字符串中的 \n / \r\n 字面量转成真实换行
export function normalizeNewlines(str) {
  if (typeof str !== 'string') return str
  return str.replace(/\\r\\n|\\n/g, '\n')
}

// 生成单词的字符数组，并把 target 子串整体标记高亮（target 仅出现一次才高亮，出现多次返回 null）
export function buildChars(word, target) {
  const w = String(word || '')
  const lower = w.toLowerCase()
  const t = (target || '').toLowerCase()
  const chars = []

  let i = 0
  while (i < lower.length) {
    if (t && lower.substring(i, i + t.length) === t) {
      for (let k = 0; k < t.length; k++) {
        chars.push({ ch: w[i + k], highlight: true })
      }
      i += t.length
    } else {
      chars.push({ ch: w[i], highlight: false })
      i++
    }
  }
  return chars
}

// 差异字母配色：与主词不同的字母按顺序轮流取色
export const DIFF_COLORS = ['#ff4757', '#1e90ff', '#2ed573', '#ffa502', '#a55eea', '#ff6348']

// 逐位对比两词：不同的字母轮流取色，相同字母用默认色
export function compareWords(a, b) {
  const maxLen = Math.max(a.length, b.length)
  let colorIdx = 0
  const res = []
  for (let i = 0; i < maxLen; i++) {
    const ca = a[i] || ''
    const cb = b[i] || ''
    if (ca !== cb) {
      res.push({ ch: ca, diff: true, color: DIFF_COLORS[colorIdx++ % DIFF_COLORS.length] })
    } else {
      res.push({ ch: ca, diff: false, color: '' })
    }
  }
  return res
}

// 在单词中标记 target 子串为高亮，返回 { chars, count }（count 为 target 出现次数）
export function markWordChars(word, target) {
  const w = String(word || '')
  const lower = w.toLowerCase()
  const t = (target || '').toLowerCase()
  const chars = []
  let count = 0
  let i = 0
  while (i < lower.length) {
    if (t && lower.substring(i, i + t.length) === t) {
      count++
      for (let k = 0; k < t.length; k++) {
        chars.push({ ch: w[i + k], highlight: true })
      }
      i += t.length
    } else {
      chars.push({ ch: w[i], highlight: false })
      i++
    }
  }
  return { chars, count }
}
